import Modal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OtpInput from 'react-otp-input';
import PhoneInput from 'react-phone-input-2';
import { CrossSvg, EditSvg, LeftArrowSvg } from '../../assets/svg';
import { toaster } from '../../services/toast-service';
import AuthBg from '../../assets/images/auth/auth-bg.png';
import LogoCircle from '../../assets/images/logo/logo.png';
import * as AuthActions from '../../redux/actions/authAction';

import 'react-phone-input-2/lib/style.css';
import { useAuth } from '../../contexts/AuthContext';
Modal.setAppElement('#root');

const LoginModal = () => {
    const { setCurrentUser } = useAuth();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isLoginModalOpen } = useSelector(state => state?.authReducer);
    const handleCloseModal = () => dispatch(AuthActions.toggleLoginModal(false));

    // Todo: Mobile
    const [inputField, setInputField] = useState({ mobile_number: '', country_code_length: '' });
    const handleInputField = (value, country) => setInputField({ mobile_number: value, country_code_length: country?.dialCode?.length }); //* Handle Input Field : Login

    //* Handle Submit : Login
    const handleSubmit = () => {
        console.log(inputField);
        if (inputField?.mobile_number?.length > 5) {
            const payload = {
                data: { phoneNumber: String(inputField?.mobile_number)?.substring(inputField?.country_code_length) },
                onComplete: () => {
                    setOtpScreen(true);
                    setResendTimer(30);
                }
            };

            //! Dispatching API
            dispatch(AuthActions.sendLoginOtp(payload));

        } else {
            toaster.warning({ text: "Please provide mobile number." });
        }
    };

    // Todo : OTP Screen
    const [customerOtp, setCustomerOtp] = useState();
    const [otpScreen, setOtpScreen] = useState(false);
    const [resendTimer, setResendTimer] = useState(0);

    const handleSubmitOtp = () => {
        if (customerOtp && customerOtp?.length == 4) {
            const payload = {
                data: { phone: String(inputField?.mobile_number)?.substring(inputField?.country_code_length), otp: customerOtp },
                onComplete: () => {
                    setOtpScreen(false);
                    handleCloseModal();
                    setCustomerOtp('');
                    setResendTimer(30);
                    setInputField({ mobile_number: '', country_code_length: '' });
                    // Redirect back to intended page if set
                    const redirect = sessionStorage.getItem('redirectAfterLogin');
                    if (redirect) {
                        sessionStorage.removeItem('redirectAfterLogin');
                        navigate(redirect);
                    }
                },
                setCurrentUserData: (data) => setCurrentUser(data)
            };

            //! Dispatching API
            dispatch(AuthActions.customerLogin(payload));

        } else {
            toaster.warning({ text: "Please Enter OTP" });
        }
    };

    //* Resend OTP 
    const handleResendOtp = () => {
        setResendTimer(30);
        setCustomerOtp(null);
        const payload = {
            data: { phoneNumber: String(inputField?.mobile_number)?.substring(inputField?.country_code_length) },
            onComplete: () => {
                setOtpScreen(true);
                setResendTimer(30);
            }
        };

        //! Dispatching API
        dispatch(AuthActions.sendLoginOtp(payload));
    };

    useEffect(() => {
        let intervalId;
        if (resendTimer > 0) intervalId = setInterval(() => { setResendTimer(prev => prev - 1); }, 1000);

        return () => clearInterval(intervalId);
    }, [resendTimer]);

    const [minHeight, setMinHeight] = useState('initial');
    useEffect(() => {
        const handleResize = () => setMinHeight(window.innerHeight * 0.95);

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <Modal isOpen={isLoginModalOpen} className="modal-content-small" onRequestClose={handleCloseModal} overlayClassName="modal-overlay" closeTimeoutMS={200} style={{ content: { backgroundColor: 'transparent' } }}>
                <section className="relative flex items-center justify-center max-md:p-5 bg-white rounded-lg">
                    <div onClick={() => handleCloseModal()} className='absolute bg-red-600 text-white p-1 rounded-full right-5 top-5 cursor-pointer'><CrossSvg /></div>

                    <article className="rounded-lg overflow-hidden max-w-4xl w-full">
                        <main className="rounded-lg max-w-4xl w-full py-5 flex bg-contain bg-center bg-no-repeat" style={{ backgroundImage: `url(${AuthBg})` }}>
                            <div className='basis-full flex flex-col px-10'>
                                <div className='min-h-16 max-h-16'><img className="object-contain h-full w-full" src={LogoCircle} /></div>

                                {otpScreen ?
                                    <main className='flex flex-col gap-5 py-5'>
                                        <div className='flex items-center gap-3'><h6 className='text-black text-2xl font-medium text-center tracking-tight'>OTP Verification</h6></div>
                                        <div className='text-gray-800 flex flex-col gap-1'>
                                            <div className='text-grey text-nowrap text-[15px]'>A OTP(One Time Password) has been sent to</div>
                                            <div className='text-grey flex items-center justify-center gap-1'>{inputField?.mobile_number?.substring(inputField?.country_code_length)}.<div onClick={() => setOtpScreen(false)} className='bg-primary text-white rounded-full p-1.5  cursor-pointer'><EditSvg h='12' w='12' /></div></div>
                                        </div>

                                        <div className='flex flex-col gap-4'>
                                            <div className='flex flex-col items-center justify-center gap-3'>
                                                <OtpInput value={customerOtp} onChange={setCustomerOtp} numInputs={4} renderSeparator={<span>-</span>} renderInput={(props) => (<input {...props} onKeyDown={(e) => e.key === 'Enter' && handleSubmitOtp()} className='border-2 outline-none text-center rounded-md' style={{ height: '40px', width: '40px' }} />)} />
                                            </div>
                                            <div className=' text-green-700 text-sm text-right'>
                                                {resendTimer > 0 ?
                                                    `Resend OTP in ${resendTimer} seconds`
                                                    :
                                                    <button onClick={handleResendOtp} className='text-green-700  text-sm  cursor-pointer hover:text-green-600'>Resend OTP</button>
                                                }
                                            </div>
                                            <button onClick={handleSubmitOtp} className="w-full shadow-lg bg-primary hover:bg-orange-600 focus:shadow-outline focus:outline-none text-white py-2 px-4 rounded transition duration-300 transform" type="submit">login</button>
                                        </div>
                                    </main>
                                    :
                                    <main className='flex flex-col gap-5 py-5'>
                                        <div className='flex items-center gap-3'><div onClick={() => handleCloseModal()} className='pt-0.5 cursor-pointer'><LeftArrowSvg /></div> <h6 className='text-black text-2xl font-medium text-center tracking-tight'>Continue with Mobile</h6></div>
                                        <p className='text-grey text-[15px]'>You will receive a 4 digit code for verification</p>

                                        <div className='flex flex-col gap-4'>
                                            <PhoneInput
                                                country={'in'}
                                                placeholder='Enter mobile no'
                                                value={inputField?.mobile_number}
                                                onChange={handleInputField}
                                                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
                                                // onlyCountries={['in']}
                                                disableCountryCode={false}
                                                countryCodeEditable={false}
                                                disableDropdown={false}
                                                inputStyle={{ width: '100%', height: '55px', fontSize: "15px", backgroundColor: "#FFF", borderRadius: '10px' }}
                                            />

                                            <button onClick={handleSubmit} className="w-full shadow-lg bg-primary hover:bg-orange-600 focus:shadow-outline focus:outline-none text-white py-2 px-4 rounded transition duration-300 transform" type="submit">Get OTP</button>

                                            <div className='text-[14px] font-[500] flex items-center justify-center gap-2'>Don't have an account?
                                                <div onClick={() => {
                                                    handleCloseModal();
                                                    dispatch(AuthActions.toggleSignupModal(true));
                                                }} className='underline text-[#0858F7] cursor-pointer'>Sign Up</div>
                                            </div>
                                        </div>
                                    </main>
                                }

                                <div className='text-xs text-center font-[500] text-[#0858F7]'>By Signing, you agree to our <Link to={'/terms-of-use'} onClick={() => handleCloseModal()} className='underline'>Terms of Use</Link> and <Link to={'/privacy-policy'} onClick={() => handleCloseModal()} className='underline'>Privacy Policy</Link></div>
                            </div>
                        </main>
                    </article>
                </section>
            </Modal>
        </>
    )
}

export default LoginModal;